import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

var LoadingProgressBar =
/*#__PURE__*/
function (_Vue) {
  _inherits(LoadingProgressBar, _Vue);

  function LoadingProgressBar() {
    var _this;

    _classCallCheck(this, LoadingProgressBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LoadingProgressBar).apply(this, arguments));
    _this.isShow = true; // 显示进度条

    _this.val = 0; // 进度

    return _this;
  } // 监听isOk, 如果是true则执行完进度条，如果是false则代表刷新重新进入


  _createClass(LoadingProgressBar, [{
    key: "finishTimer",
    value: function finishTimer() {
      console.log("isOk", this.isOk);

      if (this.isOk) {
        this.nextTimer();
      } else {
        this.val = 0;
        this.isShow = true;
        this.initTimer();
      }
    } // 初始化的定时器

  }, {
    key: "initTimer",
    value: function initTimer() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.val = _this2.initVal;
        var step = _this2.step;
        var progressBar = _this2.$refs.progressBar;

        if (progressBar) {
          var timer = setInterval(function () {
            _this2.val = _this2.val + step;
            progressBar.style.transform = "translateX(-" + (100 - _this2.val) + "%"; // 父组件数据加载完前进度条最多到stopVal的这个百分值

            if (_this2.val >= _this2.stopVal) {
              clearInterval(timer);
              return;
            }
          }, 5);
        }
      }); // 初始化后加载进度，加载到百分之多少由stopVal决定
    } // 数据加载完成之后接下来的计时器

  }, {
    key: "nextTimer",
    value: function nextTimer() {
      var _this3 = this;

      this.$nextTick(function () {
        var progressBar = _this3.$refs.progressBar;
        var step = _this3.step;
        var timer = setInterval(function () {
          _this3.val = _this3.val + step; // progressBar.style && (progressBar.style.width = val + "%");

          progressBar.style.transform = "translateX(-" + (100 - _this3.val) + "%"; // 加载到百分百完成

          if (_this3.val >= 100) {
            // 关闭定时器
            clearInterval(timer); // 加载完成关闭进度条

            _this3.isShow = _this3.completeHide; // 加载完成的回调

            _this3.$emit("endLoading");

            return;
          }
        }, 50);
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.initTimer();
    }
  }]);

  return LoadingProgressBar;
}(Vue);

tslib_1.__decorate([Prop({
  default: 5
})], LoadingProgressBar.prototype, "step", void 0);

tslib_1.__decorate([Prop({
  default: 0
})], LoadingProgressBar.prototype, "initVal", void 0);

tslib_1.__decorate([Prop({
  default: 80
})], LoadingProgressBar.prototype, "stopVal", void 0);

tslib_1.__decorate([Prop({
  default: false
})], LoadingProgressBar.prototype, "isOk", void 0);

tslib_1.__decorate([Prop({
  default: 50
})], LoadingProgressBar.prototype, "speed", void 0);

tslib_1.__decorate([Prop({
  default: false
})], LoadingProgressBar.prototype, "completeHide", void 0);

tslib_1.__decorate([Watch("isOk", {
  immediate: true
})], LoadingProgressBar.prototype, "finishTimer", null);

LoadingProgressBar = tslib_1.__decorate([Component({
  components: {}
})], LoadingProgressBar);
export default LoadingProgressBar;